import { Inject, Injectable } from '@angular/core';
import { appRouteIndex } from 'app/app.route';
import { RouteStrategyGaurd } from 'route-strategy';
import { CaslAuth } from 'casl-authorize';
import { FORBIDDEN_REDIRECT_ROUTE, IRoute, LOGIN_ROUTE } from 'route-strategy';
@Injectable({
  providedIn: 'root',
})
export class AppRouteStrategyGuard extends RouteStrategyGaurd {
  constructor(
    caslAuth: CaslAuth,
    @Inject(LOGIN_ROUTE)
    _loginRoute: IRoute,
    @Inject(FORBIDDEN_REDIRECT_ROUTE)
    _forbiddenRoute: IRoute,
  ) {
    super(_loginRoute, _forbiddenRoute);
    this.appRouteIndex = appRouteIndex;
  }
}
